import { render } from "./CommonBread.vue?vue&type=template&id=21ddded4"
import script from "./CommonBread.vue?vue&type=script&lang=js"
export * from "./CommonBread.vue?vue&type=script&lang=js"

import "./CommonBread.vue?vue&type=style&index=0&id=21ddded4&lang=scss"

import exportComponent from "E:\\公司项目\\双碳\\gdtt-front\\gdtt\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__